import { useEffect, useState } from 'react'
import { resolveSellerPanelToken } from '../services'
import useAuth from '../../../../hooks/useAuth'

export const useSellerQueuePluginspaceId = () => {
  const panelTokenFromUrl = new URLSearchParams(window.location.search).get('panelToken') || ''
  const { loginInfo } = useAuth()
  const authPluginspaceId = Number(loginInfo?.pluginspaceId || 0)
  const [pluginspaceId, setPluginspaceId] = useState<number>(0)

  useEffect(() => {
    let isMounted = true

    const loadPluginspace = async () => {
      if (!panelTokenFromUrl) {
        setPluginspaceId(authPluginspaceId > 0 ? authPluginspaceId : 0)
        return
      }

      const resolvedPluginspaceId = await resolveSellerPanelToken(panelTokenFromUrl)
      if (isMounted && resolvedPluginspaceId && resolvedPluginspaceId > 0) {
        setPluginspaceId(resolvedPluginspaceId)
      } else if (isMounted) {
        setPluginspaceId(authPluginspaceId > 0 ? authPluginspaceId : 0)
      }
    }

    loadPluginspace()

    return () => {
      isMounted = false
    }
  }, [panelTokenFromUrl, authPluginspaceId])

  return pluginspaceId
}
